import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { touchOptimizedStyles } from "shared/components/common/base-link/styles";

import IconDailyPlus from "./icons/icon-daily-plus.svg";
import IconFactSheet from "./icons/icon-factsheet.svg";
import IconPerspectives from "./icons/icon-perspectives.svg";

export const Container = styled.div`
  max-inline-size: 294px;
  padding-block-start: 24px;

  color: #30343c;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  font-feature-settings:
    "clig" off,
    "liga" off;

  ul {
    margin-block-start: 20px;
    border-block-start: 1px solid #30343c;
    li {
      display: flex;
      flex-direction: row;
      align-items: center;

      margin-block-start: 20px;
      > svg {
        min-inline-size: 60px;
        margin-inline-end: 12px;
      }
    }
  }
`;

export const Headline = styled.div`
  font-size: 24px;
`;

export const Description = styled.p`
  margin-block-start: 20px;

  font-size: 18px;
`;

export const TryForFreeButton = styled.button`
  margin-block-start: 12px;
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 700;
  line-height: 130%;
  text-transform: uppercase;

  background: #4585ff;

  cursor: pointer;

  ${touchOptimizedStyles};
`;

export const StyledIconDailyPlus = styled(IconDailyPlus)``;

export const StyledIconFactSheet = styled(IconFactSheet)``;

export const StyledIconPerspectives = styled(IconPerspectives)``;
